import { world } from '../languages';
import { AVAILABLE_WORLDS } from '../languages/constants';

const documentLang = {
    set() {
        const htmlTag = document.getElementsByTagName('html')[0];
        let value = world;

        if (world === AVAILABLE_WORLDS.GR) {
            value = 'el';
        }

        htmlTag.setAttribute('lang', value);
    }
};

export default documentLang;
